import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.dot-all.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.sticky.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.replace.js";
import userPopMixin from "@/views/system/index/mixin/userPopMixin";
export default {
  mixins: [userPopMixin],
  name: "im-search",
  data: function data() {
    return {
      searchForm: {
        pn: 1,
        ps: 20,
        keyword: this.$route.query.keyword || "",
        month: '1'
      },
      // 搜索表单

      tableLoading: false,
      tableData: [],
      // 表格数据
      total: 0
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this.getData();
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: {
    changeMonth: function changeMonth() {
      if (this.searchForm.keyword) {
        this.getData('search');
      }
    },
    setImConversationStatus: function setImConversationStatus(row, status) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return _this2.$api.setImConversationStatus({
                userId: row.user.id,
                status: status,
                keyword: _this2.searchForm.keyword
              });
            case 1:
              _this2.$message.success("操作成功");
              // 操作上报
              _this2.$operationLog.push({
                operationType: "text",
                code: "processed",
                userId: row.user.id,
                detailBatchNo: "\u5173\u952E\u8BCD\uFF1A".concat(_this2.searchForm.keyword)
              });
              _this2.tableData = _this2.tableData.filter(function (item) {
                return item.user.id != row.user.id;
              });
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    goChatRecord: function goChatRecord(row) {
      window.open("#/im/chat/record?userId=".concat(row.userId, "&otherId=").concat(row.otherId));
    },
    pageChange: function pageChange(pn) {
      this.searchForm.pn = pn;
      this.getData();
    },
    matchText: function matchText(text) {
      if (!text) return "";
      text = text.replace(new RegExp(this.searchForm.keyword, "gi"), "<em class=\"wlc-keyword-text\">".concat(this.searchForm.keyword, "</em>"));
      return text;
    },
    getData: function getData(type) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              if (type === "search") {
                _this3.searchForm.pn = 1;
              }
              _this3.tableLoading = true;
              _context3.n = 1;
              return _this3.$api.getMonitorByKeyword(_this3.searchForm);
            case 1:
              res = _context3.v;
              // res.data.list.forEach((item) => {
              //   item.msg = this.matchText(item.msg);
              // });
              _this3.tableData = res.data.list;
              _this3.total = res.data.count;
              _this3.tableLoading = false;
              _this3.getUserListByIds(_this3.tableData, "userId", "otherId");
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    }
  }
};